const doc = [({"ko":({"adminConstantHotelCancelPolicyType":({"normal":"일반", "primary":"우선"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;